import React from 'react'

import {
  Charts,
} from "xsolla-uikit";
import {
  mapdata,
} from "../../data/mapdata";

import {chartKA1} from './chartKA1'


export function PAchartUsersTime() {
  return (
    <Charts
        options={{
          chart: {
            height: 280,
            type: 'line'
          },
          tooltip: {
            header: 'Today',
            total: 21
          },
          legend: {
            enabled: false
          },
          xAxis: {
            categories: ['April', 'May', 'June', 'July', 'August', 'September', 'October', ]
          },
          yAxis: {
            title: {
              text: ''
            },
            stackLabels: {
              format: '{total} users'
            }
          },
          series: [
            {
              name: '',
              data: [10, 90, 100, 600, 700, 750, 960, 1024]
            }
          ]
        }}
      />
  )
}



export function PAchartKA({variant = 0}) {
  return (
    <Charts
        options={{
          chart: {
            height: 200,
            // type: 'line'
          },
          // tooltip: {
          //   header: 'Today',
          //   total: 21
          // },
          tooltip: {enabled: false},
          legend: {
            enabled: false
          },
          // yAxis: {
          //   title: {
          //     text: ''
          //   },
          //   stackLabels: {
          //     format: '{total} users'
          //   }
          // },
          // xAxis: {
          //   categories: ['April', 'May', 'June', 'July', 'August', 'September', 'October', ]
          // },
          // series: [
          //   {
          //     name: '',
          //     data: [10, 90, 100, 600, 700, 750, 960, 1024]
          //   }
          // ]
          // colors: [
          //   '#4662a0',
          //   '#aadb87',
          //   '#da495b',
          //   '#a87bc6',
          //   '#fde5a5',
          //   '#66ceed',
          //   '#d565ad',
          //   '#7ea45d',
          //   '#eace6b',
          //   '#66edc6',
          //   '#fdb7a5',
          // ],
          series: [{
            data: chartKA1['datasets'][variant].data,
            name: chartKA1['datasets'][variant].name,
            type: chartKA1['datasets'][variant].type,
            color: '#FFFFFF',
            // color: Highcharts.getOptions().colors[variant],
            // fillOpacity: 0.3,
            // tooltip: {
            //   valueSuffix: ' ' + dataset.unit
            // }
          }]
        }}
      />
  )
}



export function PAchartUsersMethods() {
  return (
    <Charts
        options={{
          chart: {
            height: 280,
            type: 'column'
          },
          tooltip: {
            header: 'Today',
            total: 21
          },
          legend: {
            enabled: false
          },
          xAxis: {
            categories: ['Facebook', 'Google', 'Twitter', 'Wechat', 'Taobao']
          },
          yAxis: {
            title: {
              text: ''
            },
            stackLabels: {
              format: '{total} users'
            }
          },
          series: [
            {
              name: '',
              data: [1032, 234, 533, 12, 13]
            }
          ]
        }}
      />
  )
}


export function PAchartUsersMap() {
  return (
    <Charts
          options={{
            chart: {
              height: 280,
            },
            tooltip: {
              header: "October 13, 2018",
              valueSuffix: "/km²"
            },
            colorAxis: {
              max: 300
            },
            series: [
              {
                joinBy: ["iso-a2", "code"],
                data: mapdata
              }
            ]
          }}
          constructorType="mapChart"
        />
  )
}

